import { requestService as api } from "./Request.service";

/* รายการสำหรับช่องเลือก — /api/common/options.php?type=... */
const OptionService = () => {
  const get = (type) => api.get(`/common/options.php?type=${type}`, { ignoreLoading: true });

  return {
    optionsUser: () => api.get(`/common/options-user.php`, { ignoreLoading: true }), // ตำแหน่ง (หน้าผู้ใช้งาน)
    customers: () => get("customer"),
    houseModels: () => get("house_model"),
    categories: () => get("category"),
    materials: () => get("material"),
    templates: () => get("template"),
    users: () => get("user"),
    employees: () => get("employee"),
    projects: () => get("project"),
    teamRoles: () => get("team_role"),
  };
};

export default OptionService;
